<template>
  <div class="container th-modify-study-activites-container">
    <div class="mt-100 container-style mb-100">
      <StudyFeatureHeader />
      <div class="p-20">
        <div :class="{ 'pb-20': activityMode === 'onDemand' || activityMode === 'dynamicOnly' }">
          <div class="fw-500 fs-24">
            Schedule Activity
          </div>

          <!-- Activity Scheduling  Mode section starts -->
          <div class="pt-20 mb-22 clearfix survey_qs">How would you like your activity to be sent?</div>
          <span class="activity-mode">
            <span :class="{ selected: activityMode === 'schedule' }" @click="changeActivityMode('schedule')"><img :src="activityModeIcon['schedule']" width="29" />&nbsp;&nbsp;Scheduled</span>
            <span :class="{ selected: activityMode === 'both' }" @click="changeActivityMode('both')"><img :src="activityModeIcon['both']" width="58" />&nbsp;&nbsp;Both scheduled and on-demand</span>
            <span :class="{ selected: activityMode === 'onDemand' }" @click="changeActivityMode('onDemand')"><img :src="activityModeIcon['onDemand']" width="29" />&nbsp;&nbsp;On-demand only</span>
            <span v-show="showDynamicOnly" :class="{ selected: activityMode === 'dynamicOnly' }" @click="changeActivityMode('dynamicOnly')"><img :class="{ 'selected-mode': activityMode === 'dynamicOnly', 'unselected-mode': activityMode !== 'dynamicOnly' }" class="circular-image" :src="activityModeIcon['dynamicOnly']" width="29" />&nbsp;&nbsp;Dynamic only</span>
          </span>
          <div class="pt-10 mb-2 clearfix dynamic-only-qs" v-show="activityMode === 'dynamicOnly'">Note: This activity will only be triggered by a predefined dynamic scheduling event.</div>
          <!-- Activity Scheduling  Mode section ends -->

          <div :class="{ 'activity-mode-opacity': activityMode === 'onDemand' || activityMode === 'dynamicOnly' }" class="pt-20 clearfix survey_qs">
            Which method would you like to schedule with?
          </div>
          <SchedulerComponent
            :class="{ 'activity-mode-opacity': activityMode === 'onDemand' || activityMode === 'dynamicOnly' }"
            :options="{
              validateFor: surveyData.type === 'Survey' ? 'survey' : 'epro',
              surveyId: surveyId,
              activityMode: activityMode,
              isDynamicSchedulingAvailable: true
            }"
          >
          </SchedulerComponent>
        </div>

        <div class="bt-1">
          <div class="row pt-20">
            <div class="fw-500 fs-24">
              Additional settings
            </div>
          </div>
          <div class="row pt-20">
            <label class="switch">
              <input type="checkbox" v-model="prePopulationEnabled" v-on:change="changeStatus" />
              <div class="slider round"></div>
            </label>
            <div class="pl-10">
              Show participant's their previous survey answers, if applicable. Only applies for this survey.
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="email-div">
          <div class="heading">Email recipient</div>
          <div class="email-div1">
            <div class="txt">Questions and answers included:</div>
            <div v-if="questions.length > 0">
              <div class="txt1" v-for="(question, index) in questions" :key="index">• {{ question }}</div>
            </div>
            <div class="txt1" v-if="questions.length == 0">• None</div>
          </div>
          <div class="email-div2">
            <div class="heading">Sent to:</div>
            <div>
              <b-form-checkbox v-model="sentToTeamRole" @change="notificationRecipientRole('allRoleSelected', $event, selected, selectedStudy)">
                Send notifications to the following roles:
              </b-form-checkbox>
              <span class="fa fa-info-circle info-circle pl-10 pt-10" aria-hidden="true" @click="toggleInfo()" @blur="hideInfo()" tabindex="-1"> </span>
              <div class="info-circle-div site-team" v-show="infoDiv">
                The notifications will be sent to Site Team which include Principal Investigator, Sub-Investigator, and Study Coordinator, if applicable.
              </div>
            </div>
            <div>
              <b-row>
                <b-col md="3">
                  <div>
                    <b-form-group>
                      <b-form-checkbox v-model="allSelected" :disabled="allSelectedSite" @change="notificationRecipientRole('siteTeamRoleSelected', $event)">
                        Site Team
                      </b-form-checkbox>
                      <b-form-checkbox-group id="flavors" v-model="selected" name="flavors" class="ml-20" @change="notificationRecipientRole('cancelRole', $event, selected)" aria-label="Individual SiteTeamRoles" stacked>
                        <b-form-checkbox v-for="(item, index) in SiteTeamRoles" :key="index" :disabled="item.disabled" v-b-tooltip.hover="{ placement: 'bottom', title: item.text, html: true }" :value="item.value">{{ item.text }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      {{ this.SiteTeamRoles.value }}
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="3">
                  <div>
                    <b-form-group>
                      <b-form-checkbox v-model="allSelectedStudy" :disabled="allSelectedStudyTeam" @change="notificationRecipientRole('studyTeamRoleSelected', $event)">
                        Study Team
                      </b-form-checkbox>
                      <b-form-checkbox-group id="studyTeamRoles" v-model="selectedStudy" name="studyTeamRoles" @change="notificationRecipientRole('cancelStudyRole', $event, selectedStudy)" class="ml-20" aria-label="Individual studyTeamRoles" stacked>
                        <b-form-checkbox v-for="(item, index) in studyTeamRoles" :key="index" :disabled="item.disabled" v-b-tooltip.hover="{ placement: 'bottom', title: item.text, html: true }" :value="item.value">{{ item.text }}</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mt-20">And/or other recipients:</div>
            <div class="input">
              <input type="text" placeholder="Enter email" v-model="surveyNotificationEmail.email" v-on:keyup="validateParticipants" v-validate="'required|email'" :name="`email`" :class="{ 'is-danger': emailError, 'is-success': !emailError }" />
              <button class="add left-margin" v-on:click="addNotificationEmail()" :disabled="!addRecipientBtn" :class="{ recipientBtnDisabled: !addRecipientBtn }">Add recipient</button>
              <span v-show="emailError" class="error-style">Please enter a valid email address.</span>
              <span v-show="alreadyExists" class="error-style">This email address already exists.</span>
            </div>
          </div>
          <div class="email-div3">
            <div class="txt" v-for="(item, index) in emails" :key="index">
              {{ item.email }}
              <span class="txt-remove" v-on:click="removeEmail(item.email)">
                Remove
              </span>
            </div>
          </div>
        </div>
        <div class="pt-20 mb-70">
          <span v-on:click="goBack()" class="back_link">
            <i class="fa fa-caret-left" aria-hidden="true"></i>
            Back
          </span>
        </div>
      </div>
      <div class="footerStyle">
        <div class="container">
          <div class="row">
            <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">Skip for now</button>
            <button class="btn nextBtn br-25" v-on:click="validateScheduler()">Save and Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import StudyFeatureHeader from "../common/study-features-header";
import SchedulerComponent from "../common/scheduler";
import swal from "sweetalert2";
import localStorageService from "@/services/localStorage";
import { saveAuditDetails } from '../configurator/util/saveAuditDetails';

const MODE_ICON = {
  schedule: { selected: "static/img/selected-scheduled-activity-icon.svg", unselected: "static/img/scheduled-activity-icon.svg" },
  both: { selected: "static/img/selected-scheduled-and-on-demand-activity.svg", unselected: "static/img/scheduled-and-on-demand-activity.svg" },
  onDemand: { selected: "static/img/selected-on-demand-activity-icon.svg", unselected: "static/img/on-demand-activity-icon.svg" },
  dynamicOnly: { selected: "static/img/dynamic-only-white-icon.svg", unselected: "static/img/dynamic-only-white-icon.svg" }
};

export default {
  name: "schedule-study-activity",
  data() {
    return {
      SiteTeamRoles: [
        { text: "Principal Investigator", value: "Pi", disabled: true },
        { text: "Sub-Investigator", value: "SubPi", disabled: true },
        { text: "Study Coordinator", value: "StudyCoordinator", disabled: true },
        { text: "Home Health", value: "HomeHealth", disabled: true },
        { text: "Call Center", value: "CallCenter", disabled: true },
        { text: "Rater", value: "Rater", disabled: true },
        { text: "Site Data Lock", value: "SiteDataLock", disabled: true }
      ],
      studyTeamRoles: [
        { text: "Clinical Research Associate (Blinded)", value: "Cra", disabled: true },
        { text: "Clinical Research Associate (Unblinded)", value: "CraUB", disabled: true },
        { text: "Data Management", value: "Dm", disabled: true },
        { text: "Quality", value: "Quality", disabled: true },
        { text: "Biostatistics", value: "Biostatistics", disabled: true },
        { text: "Interviewer", value: "Interviewer", disabled: true },
        { text: "Pharmacovigilance", value: "Pharmacovigilance", disabled: true },
        { text: "Home Health Coordinator", value: "Home Health Coordinator", disabled: true }
      ],
      finalSendObj: {},
      finalSendObjOld: {},
      selected: [],
      selectedStudy: [],
      allSelected: false,
      allSelectedSite: true,
      allSelectedStudy: false,
      allSelectedStudyTeam: true,
      role: [],
      infoDiv: false,
      addRecipientBtn: false,
      alreadyExists: false,
      emailError: false,
      surveyNotificationEmail: {
        email: "",
        studyId: ""
      },
      emails: [],
      questions: [],
      notifyToEmail: false,
      studyId: null,
      surveyId: null,
      studyData: {},
      surveyData: {},
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1 },
        { type: "weekly", title: "Weekly", days: 7 },
        { type: "biweekly", title: "Every 2 Weeks", days: 15 },
        { type: "monthly", title: "Monthly", days: 30 },
        { type: "biannually", title: "Bi-annually", days: 180 },
        { type: "annually", title: "Annually", days: 360 }
      ],
      questionAnswers: [],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: {},
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [{}],
        allowMultipleTimes: false,
        allowUntillDuration: false
      },
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      prePopulationEnabled: false,
      sentToTeamRole: false,
      activitySchedulingMode: "schedule",
      activityModeIcon: { schedule: MODE_ICON.schedule.unselected, both: MODE_ICON.both.unselected, onDemand: MODE_ICON.onDemand.unselected, dynamicOnly: MODE_ICON.dynamicOnly.unselected },
      studyTeamData: {},
      siteTeamData: {}
    };
  },
  components: {
    StudyFeatureHeader,
    SchedulerComponent
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.getStudyDetails();
    this.getSurveyDetails();
    this.getNotificationEmail();
    this.isQuestionEmail();
    this.getRecipientFlag();
    this.startAutoSave();
  },
  computed: {
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    activityMode: {
      get: function() {
        return this.activitySchedulingMode;
      },
      set: function(mode) {
        this.activitySchedulingMode = mode;
      }
    },
    showDynamicOnly() {
      if (this.surveyData && this.surveyData["type"]) {
        if (!this.scheduler) {
          return true;
        } else if (this.scheduler && this.scheduler.activitySchedulingMode !== "onDemand") {
          return true;
        } else if (this.scheduler && this.scheduler.activitySchedulingMode === "onDemand" && this.activityMode != "onDemand") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  watch: {
    schedulerObjChanged: {
      handler(val, oldValue) {
        if (val.schedulerObj) {
          if (val.validatedFor === "survey" || val.validatedFor === "epro") {
            if (oldValue.autoSave) {
              this.addScheduler(val.schedulerObj, val.schedulerObjOld, oldValue.autoSave);
            } else {
              this.addScheduler(val.schedulerObj, val.schedulerObjOld);
            }
          }
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "study-activities") {
      this.validateScheduler(true);
    }
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  },
  methods: {
    notificationRecipientRole(name, checked, isChecked, ele) {
      this.siteTeamData = {};
      this.studyTeamData = {};
      let role = "";
      let rolestudy = "";
      let siteTeamRoleData = [];
      this.SiteTeamRoles.forEach(siteObj => {
        siteTeamRoleData.push(siteObj.value);
      });
      let studyTeamRoleData = [];
      this.studyTeamRoles.forEach(studyObj => {
        studyTeamRoleData.push(studyObj.value);
      });
      if (name == "allRoleSelected") {
        this.SiteTeamRoles.forEach(siteObj => {
          siteObj.disabled = false;
        });
        this.studyTeamRoles.forEach(studyObj => {
          studyObj.disabled = false;
        });
        role = "siteTeamRoles";
        rolestudy = "studyTeamRoles";
        this.allSelectedSite = false;
        this.allSelectedStudyTeam = false;
        this.selected = checked ? siteTeamRoleData.slice() : [];
        this.selectedStudy = checked ? studyTeamRoleData.slice() : [];
        this.allSelected = checked;
        this.allSelectedStudy = checked;
        this.selected.forEach((i, index) => {
          this.siteTeamData[i] = "";
        });
        this.selectedStudy.forEach((i, index) => {
          this.studyTeamData[i] = "";
        });
      } else if (name == "siteTeamRoleSelected") {
        role = "siteTeamRoles";
        this.selected = checked ? siteTeamRoleData.slice() : [];
        this.selected.forEach((i, index) => {
          this.siteTeamData[i] = "";
        });
        if (this.selectedStudy.length && this.selected.length <= 0) {
          rolestudy = "studyTeamRoles";
          this.selectedStudy.forEach((i, index) => {
            this.studyTeamData[i] = "";
          });
        }
        if (this.selectedStudy.length && this.selected.length) {
          rolestudy = "studyTeamRoles";
          this.selectedStudy.forEach((i, index) => {
            this.studyTeamData[i] = "";
          });
        }
        if (this.selected.length >= this.SiteTeamRoles.length) {
          this.allSelected = true;
        } else {
          this.allSelected = false;
        }
      } else if (name == "cancelRole") {
        role = "siteTeamRoles";
        if (checked.length >= this.SiteTeamRoles.length) {
          this.allSelected = true;
        } else {
          this.allSelected = false;
        }
        checked.forEach((i, index) => {
          this.siteTeamData[i] = "";
        });
        if (this.selectedStudy.length) {
          rolestudy = "studyTeamRoles";
          this.selectedStudy.forEach((i, index) => {
            this.studyTeamData[i] = "";
          });
        }
      } else if (name == "studyTeamRoleSelected") {
        rolestudy = "studyTeamRoles";
        this.selectedStudy = checked ? studyTeamRoleData.slice() : [];
        this.selectedStudy.forEach((i, index) => {
          this.studyTeamData[i] = "";
        });
        if (this.selectedStudy.length <= 0 && this.selected.length) {
          role = "siteTeamRoles";
          this.selected.forEach((i, index) => {
            this.siteTeamData[i] = "";
          });
        }
        if (this.selectedStudy.length && this.selected.length) {
          role = "siteTeamRoles";
          this.selected.forEach((i, index) => {
            this.siteTeamData[i] = "";
          });
        }
        if (this.selectedStudy.length >= this.studyTeamRoles.length) {
          this.allSelectedStudy = true;
        } else {
          this.allSelectedStudy = false;
        }
      } else if (name == "cancelStudyRole") {
        rolestudy = "studyTeamRoles";
        if (checked.length >= this.studyTeamRoles.length) {
          this.allSelectedStudy = true;
        } else {
          this.allSelectedStudy = false;
        }
        checked.forEach((j, index) => {
          this.studyTeamData[j] = "";
        });
        if (this.selected.length) {
          role = "siteTeamRoles";
          this.selected.forEach((i, index) => {
            this.siteTeamData[i] = "";
          });
        }
      }
      let site = "";
      for (let i in this.siteTeamData) {
        site += i + ",";
      }
      let study = "";
      for (let j in this.studyTeamData) {
        study += j + ",";
      }

      if (this.allSelectedStudy && this.allSelected) {
        this.sentToTeamRole = true;
      }

      if (!this.allSelectedStudy || !this.allSelected) {
        this.sentToTeamRole = false;
      }

      let sendObj = { studyId: this.studyId, surveyId: this.surveyId, isNotificationRecipient: true };
      sendObj[role] = `${site}`;
      sendObj[rolestudy] = `${study}`;
      if (!sendObj[role] || sendObj[role] == "{}") {
        delete sendObj[role];
      }
      if (!sendObj[rolestudy] || sendObj[rolestudy] == "{}" || sendObj[""]) {
        delete sendObj[rolestudy];
      }
      this.finalSendObj = sendObj;
    },
    getRecipientFlag() {
      this.$api.getRecipientFlag(this.studyId, this.surveyId).then(
        response => {
          this.finalSendObjOld = _.cloneDeep(response.body);
          let isNotificationRecipientFlagEnabled = (response.body && response.body.isNotificationRecipient && response.body.siteTeamRoles) || (response.body && response.body.isNotificationRecipient && response.body.studyTeamRoles);
          this.sentToTeamRole = !!isNotificationRecipientFlagEnabled;
          if (isNotificationRecipientFlagEnabled) {
            if (response.body.siteTeamRoles) {
              let a = response.body.siteTeamRoles;
              let splitData = a.split(",");
              const objArray = [];
              Object.keys(splitData).forEach(key =>
                objArray.push({
                  value: splitData[key]
                })
              );
              objArray.pop();
              let site = "";
              objArray.forEach(obj => {
                site += obj.value + ",";
                this.selected.push(obj.value);
              });
              this.finalSendObj = { siteTeamRoles: `${site}` };
            }
            this.SiteTeamRoles.forEach(siteObj => {
              siteObj.disabled = false;
            });
            this.studyTeamRoles.forEach(studyObj => {
              studyObj.disabled = false;
            });
            this.allSelectedSite = false;
            this.allSelectedStudyTeam = false;
            if (this.selected.length == this.SiteTeamRoles.length) {
              this.allSelected = true;
            }
            if (response.body.studyTeamRoles) {
              let b = response.body.studyTeamRoles;
              let splitStudyData = b.split(",");
              const objStudyArray = [];
              Object.keys(splitStudyData).forEach(key =>
                objStudyArray.push({
                  value: splitStudyData[key]
                })
              );
              objStudyArray.pop();
              let study = "";
              objStudyArray.forEach(objStudy => {
                study += objStudy.value + ",";
                this.selectedStudy.push(objStudy.value);
              });
              this.finalSendObj["studyTeamRoles"] = `${study}`;
            }
            if (response.body.siteTeamRoles) {
              if (this.selected.length == this.SiteTeamRoles.length) {
                this.allSelected = true;
              } else {
                this.allSelected = false;
              }
            }
            if (response.body.studyTeamRoles) {
              if (this.selectedStudy.length == this.studyTeamRoles.length) {
                this.allSelectedStudy = true;
              } else {
                this.allSelectedStudy = false;
              }
            }

            this.areAllSiteAndStudyMembersSelected();
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    areAllSiteAndStudyMembersSelected() {
      if (this.selectedStudy.length === this.studyTeamRoles.length && this.selected.length === this.SiteTeamRoles.length) {
        this.sentToTeamRole = true;
      } else {
        this.sentToTeamRole = false;
      }
    },
    validateParticipants() {
      if (this.surveyNotificationEmail.email === "" || this.surveyNotificationEmail.email === null) {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.validateEmail(this.surveyNotificationEmail.email) === false) {
        this.emailError = true;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.isEmailExists(this.surveyNotificationEmail.email) === true) {
        this.emailError = false;
        this.alreadyExists = true;
        this.addRecipientBtn = false;
      } else {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = true;
      }
    },
    removeEmail(email) {
      swal({
        title: "Are you sure you want to remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Remove"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.surveyNotificationEmail.studyId = this.studyId;
          this.surveyNotificationEmail.email = email;
          this.$api.removeEmail(this.surveyId, this.surveyNotificationEmail).then(
            response => {
              saveAuditDetails(this.$api, this.studyId, {
                section: "Customize",
                element: "Activity Schedule Email Recipient",
                httpMethod: "DELETE",
                url: response.url.substring(response.url.indexOf("/api")),
                changeFrom: [...this.emails],
                changeTo: response.body
              });
              this.emails = response.body;
              this.surveyNotificationEmail.email = "";
              this.emailError = false;
              this.alreadyExists = false;
              this.addRecipientBtn = false;
            },
            error => {
              toastr.error(error.body ? error.body.message : "Error while getting the study details");
            }
          );
        }
      });
    },
    setValueOfIsNotificationRecipientFlag() {
      /* This method sets value of the boolean variable 'isNotificationRecipient' , thus further determining if emails will be send to recipients or not. */
      this.isNotificationRecipient = false;

      if (this.emails && this.emails.length) {
        /* Atleast 1 email is added. */
        this.isNotificationRecipient = true;
      } else if ((this.selected && this.selected.length) || (this.selectedStudy && this.selectedStudy.length)) {
        /*  Atleast 1 member is added. */
        this.isNotificationRecipient = true;
      }
    },
    getNotificationEmail() {
      this.$api.getNotificationEmails(this.surveyId, this.studyId).then(
        response => {
          this.emails = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    addNotificationEmail() {
      if (this.surveyNotificationEmail.email === "" || this.surveyNotificationEmail.email === null) {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.validateEmail(this.surveyNotificationEmail.email) === false) {
        this.emailError = true;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.isEmailExists(this.surveyNotificationEmail.email) === true) {
        this.emailError = false;
        this.alreadyExists = true;
        this.addRecipientBtn = false;
      } else {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = true;
        this.surveyNotificationEmail.studyId = this.studyId;
        this.$api.addEmailForNotification(this.surveyId, this.surveyNotificationEmail).then(
          response => {
            saveAuditDetails(this.$api, this.studyId, {
              section: "Customize",
              element: "Activity Schedule Email Recipient",
              httpMethod: "POST",
              url: response.url.substring(response.url.indexOf("/api")),
              changeFrom: [...this.emails],
              changeTo: response.body
            });
            this.emails = response.body;
            this.surveyNotificationEmail.email = "";
            this.addRecipientBtn = false;
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while getting the study details");
          }
        );
      }
    },
    isEmailExists(email) {
      const e = this.emails;
      let result = false;
      for (let i = 0; i < e.length; i++) {
        if (e[i].email === email) {
          result = true;
        }
      }
      return result;
    },
    validateEmail(email) {
      const re = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/; // eslint-disable-line
      return re.test(email);
    },
    isQuestionEmail() {
      let temp = this.notifyToEmail;
      let q = this.questions;

      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          // questions = response.body.questions;
          response.body.questions.map(function(value, key) {
            // eslint-disable-line
            if (value.isNotifyToEmail) {
              temp = true;
              q.push(value.body);
            }
          });
          this.notifyToEmail = temp;
          this.questions = q;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    goBack() {
      window.history.back();
    },
    skipForNow() {
      this.$router.push({
        name: "study-activities",
        params: { studyId: this.studyId }
      });
    },
    validateScheduler(autoSave = false) {
      let hasSendNotification = !!(this.selected.length > 0 || this.selectedStudy.length > 0 || this.sentToTeamRole || this.emails.length != 0);
      if (this.surveyData.type === "Survey") {
        if (this.notifyToEmail) {
          if (hasSendNotification) {
            if (!autoSave) {
              this.$store.dispatch("addSchedule", { validateFor: "survey" });
            } else {
              this.$store.dispatch("addSchedule", { validateFor: "survey", autoSave: autoSave });
            }
          } else {
            if (!autoSave) {
              toastr.error("Please enter at least one email recipient.");
            }
          }
        } else {
          if (!autoSave) {
            this.$store.dispatch("addSchedule", { validateFor: "survey" });
          } else {
            this.$store.dispatch("addSchedule", { validateFor: "survey", autoSave: autoSave });
          }
        }
      } else {
        if (!autoSave) {
          this.$store.dispatch("addSchedule", { validateFor: "epro" });
        } else if (this.studyData.screeningMilestoneAllowed == undefined || this.studyData.screeningMilestoneAllowed == false) {
          this.$store.dispatch("addSchedule", { validateFor: "epro", autoSave: autoSave });
        }
      }
    },
    getSurveyDetails() {
      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          this.surveyData = response.body;
          this.prePopulationEnabled = response.body.prePopulationEnabled;
          this.scheduler = response.body.scheduler ? response.body.scheduler : this.scheduler;
          if (response.body.scheduler) {
            this.activityMode = this.surveyData.scheduler.activitySchedulingMode;
            this.activitySchedulingMode = this.surveyData.scheduler.activitySchedulingMode;
          } else if (response.body.segmentSchedules && !!response.body.segmentSchedules) {
            this.activityMode = this.surveyData.segmentSchedules[0].activitySchedulingMode;
            this.activitySchedulingMode = this.surveyData.segmentSchedules[0].activitySchedulingMode;
          } else {
            this.activityMode = "schedule";
          }
          this.setActivityModeIcon(this.activityMode);
          this.$store.dispatch("setSurveyDetailsAction", response.body);
          if (this.surveyData.questions && this.surveyData.questions.length > 0) {
            this.timeToComplete = this.surveyData.timeToComplete;
            this.questionAnswers = response.body.questions;
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    getStudyDetails() {
      try {
        this.studyData = localStorageService.getItem("studyDetailsData")[this.studyId] || {};
      } catch (e) {
        console.error(e);
        this.studyData = {};
      }
    },
    addScheduler(scheduleObj, scheduleObjOld, autoSave = false) {
      this.setValueOfIsNotificationRecipientFlag();
      if (!this.finalSendObj.studyId) {
        this.finalSendObj.studyId = this.studyId;
      }
      this.finalSendObj.isNotificationRecipient = this.isNotificationRecipient;
      this.$api.configuredRecipient(this.surveyId, this.finalSendObj).then(
        response => {
          saveAuditDetails(this.$api, this.studyId, {
            section: "Customize",
            element: "Activity Schedule Recipient Configuration",
            httpMethod: "POST",
            url: response.url.substring(response.url.indexOf("/api")),
            changeFrom: this.finalSendObjOld || {},
            changeTo: response.body
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while configuring recipient");
          return;
        }
      );
      this.$api.postSchedulingFact(this.studyId, scheduleObj).then(
        response => {
          saveAuditDetails(this.$api, this.studyId, {
            section: "Customize",
            element: "Activity Schedule",
            httpMethod: "PUT",
            url: response.url.substring(response.url.indexOf("/api")),
            changeFrom: scheduleObjOld || {},
            changeTo: response.data
          });
          if (!autoSave) {
            toastr.success("Scheduling completed successfully");
            this.$router.push({
              name: "study-activities",
              params: { studyId: this.studyId }
            });
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
        }
      );
    },
    changeStatus() {
      let data = {};
      data.prePopulationEnabled = this.prePopulationEnabled;
      this.$api.updateSurveyPrepopulationFact(this.surveyId, this.studyId, data).then(
        response => {
          saveAuditDetails(this.$api, this.studyId, {
            section: "Customize",
            element: "Activity Schedule",
            httpMethod: "PUT",
            url: response.url.substring(response.url.indexOf("/api")),
            changeFrom: { prePopulationEnabled: !this.prePopulationEnabled },
            changeTo: { prePopulationEnabled: this.prePopulationEnabled }
          });
          this.prePopulationEnabled = response.body.prePopulationEnabled;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while updating the survey details");
        }
      );
    },
    hideInfo() {
      this.infoDiv = false;
      this.$el.blur();
    },
    showInfo() {
      this.infoDiv = true;
      this.$el.focus();
    },
    toggleInfo() {
      if (this.infoDiv) {
        this.hideInfo();
      } else {
        this.showInfo();
      }
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.validateScheduler(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    changeActivityMode(mode) {
      this.activitySchedulingMode = mode;
      this.setActivityModeIcon(mode);
    },
    setActivityModeIcon(mode) {
      for (let prop in this.activityModeIcon) {
        if (prop === mode) {
          this.activityModeIcon[prop] = MODE_ICON[prop]["selected"];
        } else {
          this.activityModeIcon[prop] = MODE_ICON[prop]["unselected"];
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.th-modify-study-activites-container {
  .bg-green {
    background-color: #2ecc71 !important;
  }

  .bt-1 {
    border-top: 1px solid #d3dfe4;
  }

  .bg-red {
    background-color: #ff7171 !important;
  }

  .container-style {
    border-radius: 2px;
    background-color: #ffffff;
    color: #666769;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  }

  .example {
    margin: 40px 40px 20px 40px;
  }
  .example-content {
    padding: 20px 40px 20px 40px;
  }
  .example-header {
    padding: 20px 80px 10px 80px;
    font-weight: bold;
  }

  .form-control {
    border-radius: 2px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 23px;
  }
  /* Hide default HTML checkbox */
  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid #ccc;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 1px;
    background-color: #ccc;
  }
  input:checked + .slider {
    border: 2px solid #48bf7a;
  }
  input:checked + .slider:before {
    content: "";
    background-color: #48bf7a;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }
  input:checked + .slider:before {
    /*content: '✓';*/
    position: absolute;
    color: #2ecc71;
    text-align: center;
    font-size: 20px;
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }

  .footerStyle {
    .row {
      display: block;

      &:after {
        content: "";
        clear: both;
        display: block;
      }
    }
  }

  .back_link {
    color: #6d6d88 !important;
  }

  .survey_qs {
    font-weight: 600;
    color: #666769;
  }

  .dynamic-only-qs {
    font-weight: 600;
    color: #666669;
    font-size: 13px;
  }

  .activity-mode {
    margin-bottom: 22px;
    display: inline-block;
    & span {
      padding: 16px 28px 16px 11px;
      margin-right: 13px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
      font-size: 15px;
      & img {
        &.selected-mode {
          background-color: #4c8ce4;
        }
        &.unselected-mode {
          background-color: #d3dfe4;
        }
        &.circular-image {
          padding: 6px;
          border-radius: 50%;
          height: 29px;
          width: 29px;
        }
      }
      &.selected {
        background: #34537d;
        border-radius: 3px;
        color: #ffffff;
        border: solid 1px #4c8ce4;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  .activity-mode-opacity {
    /* visibility: hidden; */
    display: none;
  }

  .add {
    width: 120px;
    height: 30px;
    border-radius: 4px;
    background-color: #1e8fe1;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    border: none;
  }

  .left-margin {
    margin-left: 20px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: #d3dfe4;
    margin-top: 30px;
  }

  .email-div {
    margin-top: 30px;
    margin-bottom: 50px;

    .heading {
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.6;
      letter-spacing: normal;
      color: #666669;
    }

    .email-div1 {
      margin-top: 20px;

      .txt {
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #666669;
      }

      .txt1 {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #666669;
      }
    }

    .email-div2 {
      margin-top: 30px;

      .heading {
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #666669;
      }

      input[type="text"] {
        width: 300px;
        height: 40px;
        border-radius: 3px;
        border: 1px solid #d3dfe4;
        padding: 10px 8px;
      }

      input[type="text"]::placeholder {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #c5d1d6;
      }
    }

    .email-div3 {
      margin-top: 20px;

      .txt {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #666669;
      }

      .txt-remove {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #f16559;
        padding-left: 20px;
        cursor: pointer;
      }
    }
  }

  .error-style {
    font-size: 12px;
    color: #ff4848;
    padding-bottom: 5px;
    padding-left: 0;
    display: block;
  }

  .is-danger {
    border-width: 2px;
    border-radius: 5px;
    border-color: #f16559 !important;
  }

  .recipientBtnDisabled {
    opacity: 0.5;
  }

  .checkbox_position {
    position: relative;
    top: 2px;
  }

  .info-circle-div {
    width: 330px;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #666669;
    padding: 15px 18px;
    position: absolute;
    border-radius: 3px;
    margin-left: 320px;
    margin-top: -70px;
    border: 1px solid #dbe5e9;
    z-index: 111;
  }
  .site-team {
    width: 390px;
    margin-top: -88px;
  }

  .info-circle {
    padding: 0 15px;
  }
}
</style>
